export default "__VITE_ASSET__b30ed0ba__"